<mat-toolbar>
    <button mat-icon-button>
        <mat-icon [svgIcon]="item.icon"></mat-icon>
    </button>
    <a *ngIf="!editMode"
       (click)="changeState()"
       [ngClass]="{ 'cl-disabled': !item.isEnabled }"
       class="area-link"
    >
        <cl-alert-bubble class="text-spacer" [alertColor]="item.alertColor"
                         [alertCount]="item.alertCount" [text]="item.text"></cl-alert-bubble>
    </a>

    <cas-form-field-input
            *ngIf="editMode"
            [model]="item.text"
            (modelChange)="updateText($event)"
    >
    </cas-form-field-input>
    <span class="spacer"></span>

    <cas-button
            [iconButton]="true"
            materialIcon="edit"
            *ngIf="item.editAction && !editMode"
            (clickAction)="toggleEditMode()"
            [color]="null"
            iconClass="area-menu-icon"
    >
    </cas-button>
    <cas-button
            [iconButton]="true"
            materialIcon="save"
            *ngIf="item.editAction && editMode"
            (clickAction)="performEditAction()"
            [color]="null"
            iconClass="area-menu-icon"
    >
    </cas-button>
    <cas-button
            [iconButton]="true"
            materialIcon="cancel"
            *ngIf="item.editAction && editMode"
            (clickAction)="cancelEditMode()"
            [color]="null"
            iconClass="area-menu-icon"
    >
    </cas-button>
    <cas-button
            [iconButton]="true"
            materialIcon="delete"
            *ngIf="item.deleteAction"
            (clickAction)="deleteArea()"
            [color]="null"
            iconClass="area-menu-icon"
    >
    </cas-button>
</mat-toolbar>
<mat-divider></mat-divider>
